import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from '@carm/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { ApplyCreditsPageComponent } from './apply-credits-page/apply-credits-page.component';
import { CreditConfirmComponent } from './credit-confirm/credit-confirm.component';
import { OnlinePaymentComponent } from './online-payment/online-payment.component';

/**
 * For components that are shared between modules.
 */
@NgModule({
  declarations: [
    ApplyCreditsPageComponent,
    OnlinePaymentComponent,
    CreditConfirmComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    SharedModule
  ],
  providers: [],
})
export class DashboardSharedModule { }
